import {
  createContext,
  useContext,
  type ReactNode,
} from "react";
import type { UsuariosGateway } from "../infrastructure/usuarios.gateway";

const Contexto = createContext<UsuariosGateway | null>(null);

export function ProvedorDeUsuarios({
  gateway,
  children,
}: {
  readonly gateway: UsuariosGateway;
  readonly children: ReactNode;
}) {
  return <Contexto.Provider value={gateway}>{children}</Contexto.Provider>;
}

export function useUsuariosGateway(): UsuariosGateway {
  const gateway = useContext(Contexto);
  if (!gateway) {
    throw new Error("useUsuariosGateway fora do ProvedorDeUsuarios");
  }
  return gateway;
}
